import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    cardWrapper: {
      // position: 'absolute',
      bottom: '68px',
      top: '400px',
      left: '41px',
      right: '41px',
      margin: '0px 40px',
      overflow: 'auto',
    },
    stepperContainer: {
      boxShadow: '0px 2px 10px #3F434714',
      margin: '24px 40px',
      padding: '1px 20px 20px',
    },
  }),
  { index: 1 },
)

export { useStyles }
